module.exports = __webpack_public_path__ + "static/media/drone_race.4fcc9b28.png";